import { useState, useEffect } from "react";

const PhoneInput = ({
  value,
  onChange,
  placeholder,
  placeholderMain,
  placeholderExt,
  isMobile = false,
  isWork = false,
}) => {
  const [mainValue, setMainValue] = useState("");
  const [extValue, setExtValue] = useState("");

  useEffect(() => {
    if (isWork && typeof value === "object") {
      setMainValue(value.main || "");
      setExtValue(value.ext || "");
    } else if (isMobile) {
      setMainValue(value || "");
    }
  }, [value, isMobile, isWork]);

  const formatMobilePhone = (input) => {
    const cleaned = input.replace(/\D/g, "");

    if (cleaned.startsWith("7") || cleaned.startsWith("8")) {
      const numbers = cleaned.slice(1);
      let formatted = "+7";

      if (numbers.length > 0) formatted += ` (${numbers.slice(0, 3)}`;
      if (numbers.length > 3) formatted += `) ${numbers.slice(3, 6)}`;
      if (numbers.length > 6) formatted += `-${numbers.slice(6, 8)}`;
      if (numbers.length > 8) formatted += `-${numbers.slice(8, 10)}`;

      return formatted;
    }

    return input;
  };

  const formatWorkPhone = (input) => {
    const cleaned = input.replace(/\D/g, "");

    if (cleaned.startsWith("7") || cleaned.startsWith("8")) {
      const numbers = cleaned.slice(1);
      let formatted = "+7";

      if (numbers.length > 0) formatted += ` (${numbers.slice(0, 3)}`;
      if (numbers.length > 3) formatted += `) ${numbers.slice(3, 6)}`;
      if (numbers.length > 6) formatted += `-${numbers.slice(6, 8)}`;
      if (numbers.length > 8) formatted += `-${numbers.slice(8, 10)}`;

      return formatted;
    }

    return input;
  };

  const handleMainChange = (e) => {
    const input = e.target.value;
    let formatted;

    if (isMobile) {
      formatted = formatMobilePhone(input);
      setMainValue(formatted);
      onChange(formatted);
    } else {
      formatted = formatWorkPhone(input);
      setMainValue(formatted);
      onChange(formatted, extValue);
    }
  };

  const handleExtChange = (e) => {
    const input = e.target.value.replace(/\D/g, "");
    setExtValue(input);
    onChange(mainValue, input);
  };

  if (isWork) {
    return (
      <div className="work-phone-input">
        <div className="phone-main-wrapper">
          <input
            type="tel"
            value={mainValue}
            onChange={handleMainChange}
            placeholder={placeholderMain}
            className="phone-main-input"
          />
        </div>
        <div className="phone-ext-wrapper">
          <span className="ext-label">доб.</span>
          <input
            type="text"
            value={extValue}
            onChange={handleExtChange}
            placeholder={placeholderExt}
            className="phone-ext-input"
            maxLength="6"
          />
        </div>
      </div>
    );
  }

  return (
    <input
      type="tel"
      value={mainValue}
      onChange={handleMainChange}
      placeholder={placeholder}
      className="phone-input"
    />
  );
};

export default PhoneInput;
